import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { PricingSection } from './PricingSection';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 bg-beige-dark/20 border-t border-beige-dark" data-id="element-117">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-118">
        <div className="mb-16" data-id="element-119">
          <CountdownTimer data-id="element-120" />
        </div>

        <PricingSection data-id="element-121" />

        <div className="mt-16 flex flex-wrap justify-center gap-6 md:gap-12 text-sm font-medium text-gray-600" data-id="element-122">
          <div className="flex items-center gap-2" data-id="element-123">
            <Lock className="w-5 h-5 text-gold" data-id="element-124" />
            <span data-id="element-125">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-126">
            <Zap className="w-5 h-5 text-gold" data-id="element-127" />
            <span data-id="element-128">Acceso en 5 minutos</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-129">
            <Shield className="w-5 h-5 text-gold" data-id="element-130" />
            <span data-id="element-131">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-132">
            <CreditCard className="w-5 h-5 text-gold" data-id="element-133" />
            <span data-id="element-134">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}